import { type FunctionComponent } from "preact";
import SiteCookiesTable from "core/SiteCookiesTable";
import EmbedContainer from "core/EmbedContainer";

const SiteCookiesListEmbed: FunctionComponent = () => {
  return (
    <EmbedContainer>
      {({ scan }) => (
        <SiteCookiesTable
          layout="alternate"
          cookies={scan.cookies}
          updatedAt={scan.cookie_list_updated_at}
        />
      )}
    </EmbedContainer>
  );
};

export default SiteCookiesListEmbed;
